<div class="margin-top-lg">
    <mat-card-title>
        <div class="row">
            <div class="col-4">
                Individual Needs Assessment/Individual Learning Plan
            </div>
            <mat-icon *ngIf="isLoading">
                <mat-spinner *ngIf="isLoading" diameter="18"></mat-spinner>
            </mat-icon>
            <div class="col-8" *ngIf="editing">
                <button *ngIf="addAccess" mat-raised-button color="primary" class="button-add-row"
                    (click)="addRow()">Add
                    INA/ILP</button>
            </div>
        </div>
    </mat-card-title>
    <div class="row" style="padding-top: 5px;">
        <div class="col">
            <mat-divider></mat-divider>
        </div>
    </div>
    {{ boolFoundINAILP ==false ? studentName + ' does not have any INA/ILPs.' : '' }}

    <div *ngFor="let item of lstRegionbyGroup">
        <div style="padding-top: 10px" *ngIf="this.userRegion &&  item?.editableINA[0].inaSchoolEnrollment?.RegionId && item?.editableINA[0]?.inaSchoolEnrollment?.RegionId == this.userRegion?.ID">
            <app-ina-table (modificationEvent)="invokeApiGetINA($event)" [inaSchoolEnrollments]="item.editableINA"
                [studentId]="studentId" [editing]="editing"></app-ina-table>
        </div>
        <br />
    </div>
    <div *ngFor="let item of lstRegionbyGroup">
        <div *ngIf="item.editableINA[0].inaSchoolEnrollment.RegionId != this.userRegion?.ID">
            <app-ina-table (modificationEvent)="invokeApiGetINA($event)" [inaSchoolEnrollments]="item.editableINA"
                [studentId]="studentId" [editing]="editing"></app-ina-table>
        </div>
        <br />
    </div>
</div>